import { render } from "./LightPerf.vue?vue&type=template&id=76bf68e0&scoped=true&ts=true"
import script from "./LightPerf.vue?vue&type=script&lang=ts"
export * from "./LightPerf.vue?vue&type=script&lang=ts"

import "./LightPerf.vue?vue&type=style&index=0&id=76bf68e0&scoped=true&lang=css"
import "./LightPerf.vue?vue&type=style&index=1&id=76bf68e0&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bf68e0"]])

export default __exports__